import styled from 'styled-components';

import S from '../variables';

export const StyledPairedButtonWrapper = styled.div`
  display: flex;
`;

export const StyledPairedButton = styled.button`
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 17px 22px;
  border: 1px solid ${S.pairedButton};
  font-family: 'Sora', sans-serif;
  font-size: 12px;
  font-weight: 400;
  text-transform: lowercase;
  &::first-letter {
    text-transform: uppercase;
  }
  &[disabled] {
    background: ${S.pairedButtonDisabled};
    color: ${S.pairedButton};
    cursor: not-allowed;
  }
  @media screen and (min-width: ${S.tablet}) {
    font-size: 20px;
    padding: 25px 50px;
    &.small {
      font-size: 12px;
      padding: 17px 22px;
    }
  }
  &:not([disabled]):hover {
    background: ${S.pairedButtonHover};
    color: ${S.pairedButton};
  }
  transition: background ${S.trFast}, color ${S.trFast};
  &:not([disabled]) {
    background-color: #fff;
    border: 1px solid ${S.pairedButton};
    color: ${S.mainGreyText};
  }
  &.active:not([disabled]) {
    background-color: ${S.pairedButton};
    border: 1px solid ${S.pairedButton};
    color: #fff;
  }
  &:first-child {
    border-radius: 5px 0 0 5px;
  }
  &:last-child {
    border-radius: 0 5px 5px 0;
  }
`;
